import { CSSProperties } from "react";
import { Theme } from "@mui/material/styles";

export interface LocationStyles {
  container: CSSProperties;
  header: CSSProperties;
  content: CSSProperties;
  billetItem: CSSProperties;
  moreIndicator: CSSProperties;
  footer: CSSProperties;
  heatGroupHeader: CSSProperties;
  heatItem: CSSProperties;
  heatNumber: CSSProperties;
  heatCount: CSSProperties;
  emptyState: CSSProperties;
}

export const createLocationStyles = (
  isSelected: boolean,
  isSearchHighlighted: boolean,
  totalBillets: number,
  theme: Theme,
): LocationStyles => {
  const getBackgroundColor = () => {
    if (isSelected) {
      return theme.palette.billetYard.selected.background; // Yellow highlight
    }
    if (isSearchHighlighted) {
      return "#93BFEF"; // Light blue for search match
    }
    return totalBillets > 0 ? theme.palette.grey[50] : theme.palette.grey[100];
  };

  return {
    container: {
      border: isSearchHighlighted
        ? "2px solid #468BE6"
        : `1px solid ${theme.palette.billetYard.borders.light}`,
      borderRadius: "5px",
      backgroundColor: getBackgroundColor(),
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: isSearchHighlighted
        ? "0 0 8px rgba(70, 139, 230, 0.3)"
        : undefined,
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      color: "white",
      padding: "6px",
      borderRadius: "5px 5px 0 0",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "16px",
      flexShrink: 0,
    },
    content: {
      padding: "4px",
      flex: 1,
      minHeight: 0,
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      gap: "2px",
    },
    billetItem: {
      padding: "6px 4px",
      fontSize: "14px",
      borderRadius: "3px",
      flexShrink: 0,
      minHeight: "40px",
    },
    moreIndicator: {
      padding: "2px 4px",
      fontSize: "14px",
      color: theme.palette.text.secondary,
      fontStyle: "italic",
      textAlign: "center",
      backgroundColor: theme.palette.grey[200],
      borderRadius: "2px",
      flexShrink: 0,
    },
    footer: {
      backgroundColor: theme.palette.billetYard.backgrounds.light,
      padding: "4px",
      borderRadius: "0 0 5px 5px",
      textAlign: "center",
      fontSize: "14px",
      fontWeight: "bold",
      color: theme.palette.text.primary,
      flexShrink: 0,
    },
    heatGroupHeader: {
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.text.primary,
      textAlign: "center",
      fontWeight: "bold",
      marginBottom: "1px",
      minHeight: "auto",
      padding: "6px 4px",
      fontSize: "13px",
      borderRadius: "3px 3px 0 0",
    },
    heatItem: {
      display: "flex",
      flexDirection: "column",
      gap: "1px",
      minHeight: "32px",
      padding: "4px 6px",
    },
    heatNumber: {
      fontSize: "15px",
      fontWeight: "500",
      color: theme.palette.text.primary,
      textAlign: "center",
      flex: "1 1 0%",
    },
    heatCount: {
      fontSize: "14px",
      color: theme.palette.text.secondary,
      fontWeight: "500",
      minWidth: "20px",
      textAlign: "right",
    },
    emptyState: {
      fontSize: "11px",
      color: theme.palette.text.secondary,
      textAlign: "center",
      padding: "10px 0",
    },
  };
};
